import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { IOptionsResponse } from '../../../common/common.types'
import { OptionsService } from '../services/options.service'
import { setFactorsOptions } from '../store/options.actions'
import { moveOptionToEnd } from '../../../utilities/options.util'

export function* getFactorsOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getFactorsOptions])
    const { entity } = response
    moveOptionToEnd(entity, 20)
    yield put(setFactorsOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getFactorsOptions() error: ${e}`))
  }
}

export function* getFactorsOptionsFactorsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getFactorsOptions)
}
